import React from 'react';
import '../styles/WalletPage.css';
import { BackgroundStars } from '../components/BackgroundStars';
import { NavigationBar } from '../components/NavigationBar';
import { useGameStore } from '../store/gameStore';
import { useNavigate } from 'react-router-dom';
import { giftAPI } from '../services/api';

type WithdrawalItem = {
  id: number;
  recipient: string;
  giftTitle: string;
  withdrawStars: number;
  status: 'queued' | 'sent' | 'failed';
  queueId?: string | null;
};

const STATUS_LABEL: Record<WithdrawalItem['status'], string> = {
  queued: 'В очереди',
  sent: 'Отправлен',
  failed: 'Ошибка',
};

const WalletPage: React.FC = () => {
  const { stars } = useGameStore();
  const navigate = useNavigate();
  const [withdrawals, setWithdrawals] = React.useState<WithdrawalItem[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    const loadHistory = async () => {
      try {
        setIsLoading(true);
        const response = await giftAPI.getWithdrawHistory({ limit: 20 });
        if (response?.success && Array.isArray(response.items)) {
          setWithdrawals(response.items);
        }
      } catch (error) {
        console.error('Failed to load withdraw history:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadHistory();
  }, []);

  // Обработчик кнопки вывода средств
  const handleWithdraw = () => {
    navigate('/withdraw');
  };

  return (
    <div className="wallet-page">
      <BackgroundStars />
      
      <header className="wallet-header">
        <div className="wallet-title">SaperStars</div>
        <div className="wallet-score">
          <span className="score-value">{stars.toFixed(1)}</span>
          <span className="score-icon">⭐</span>
        </div>
      </header>

      <div className="wallet-container">
        {/* Секция баланса */}
        <div className="balance-section">
          <h2 className="balance-title">Ваш баланс</h2>
          <div className="balance-value">
            {stars.toFixed(1)} <span className="balance-star">⭐</span>
          </div>
        </div>
        
        {/* Секция выводов */}
        <div className="withdrawals-section">
          <h2 className="withdrawals-title">Ваши выводы</h2>
          
          <div className="withdrawals-info">
            <div className="withdrawals-header">
              <div className="withdrawals-header-item">Аккаунт</div>
              <div className="withdrawals-header-item">Звезды</div>
              <div className="withdrawals-header-item">Статус</div>
            </div>
            
            <div className="withdrawals-content">
              {isLoading && <div className="no-withdrawals-message">Загрузка...</div>}

              {!isLoading && withdrawals.length === 0 && (
                <div className="no-withdrawals-message">Вы еще не выводили звезды</div>
              )}

              {!isLoading &&
                withdrawals.map((item) => (
                  <div key={item.id} className="withdrawal-item">
                    <div className="withdrawal-account">
                      @{item.recipient}
                      <div className="withdrawal-subtext">{item.giftTitle}</div>
                    </div>
                    <div className="withdrawal-amount">{item.withdrawStars} ⭐</div>
                    <div className={`withdrawal-status withdrawal-status--${item.status}`}>
                      {STATUS_LABEL[item.status]}
                      {item.queueId ? <div className="withdrawal-subtext">#{item.queueId}</div> : null}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
        
        {/* Кнопка вывода */}
        <button className="withdraw-button" onClick={handleWithdraw}>
          Вывести
        </button>
      </div>
      
      <NavigationBar />
      
    </div>
  );
};

export default WalletPage; 